import React, { useContext } from "react";
import ReactDOM from "react-dom";
import { StyleSheet, View } from "react-native";
import Toast from "webComponentsFormElements/Toast.component";
import { ToastContext } from "webContext/Toast.context";

const classes = StyleSheet.create({
  container: {
    position: "absolute",
    right: 0,
    bottom: 0,
    padding: 15,
    flex: 1,
    gap: 15,
    zIndex: 2000,
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
});

export default function ToastContainer() {
  const { toasts, removeToast } = useContext(ToastContext);

  const container = (
    <View style={classes.container}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onHide={() => removeToast(toast.id)}
        />
      ))}
    </View>
  );

  return ReactDOM.createPortal(container, document.body);
}
